"use client";

import { useTranslations } from "next-intl";

import { CategoryExploreList } from "../audio/CategoryExploreList";
import type { CategoryExploreListProps, SoundEffectExploreItem } from "../audio/CategoryExploreList";

type MusicExploreListProps = Omit<CategoryExploreListProps, "labels">;

function MusicExploreList(props: MusicExploreListProps) {
  const tGlobals = useTranslations("ClientKeys.Globals");
  const t = useTranslations("ClientKeys.MusicExploreList");
  return (
    <CategoryExploreList
      {...props}
      labels={{
        headerCountSuffix: tGlobals("tracks"),
        generateCtaDefaultLabel: t("generate_your_own_music"),
      }}
      showDurationColumn
      showWaveform
      downloadButtonStyle='icon-text'
    />
  );
}

MusicExploreList.displayName = "MusicExploreList";

export { MusicExploreList };
export type { MusicExploreListProps, SoundEffectExploreItem };
